<template>
  <div class="promo">
    <div class="promo-container">
      <div class="promo-image">
        <img
          :src="imageSrc"
          :srcset="imageSrcset"
          :sizes="imageSizes"
          alt="The Midnight Miracle"
        />
      </div>
      <div class="promo-description">
        <div class="promo-header">The Midnight Miracle</div>
        <div class="promo-subtitle">Talib Kweli, yasiin bey, and Dave Chappelle</div>
        <div class="promo-listen">
          <el-button
            class="el-button--primary cta-button"
            @click="() => handleCTAClick('home_promo')"
          >Listen Now</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import groupShot750 from '../../../assets/images/web2/home/TMM-Featured-750.png';
// import groupShot1000 from '../../../assets/images/web2/home/TMM-Featured-1000.jpg';
// import groupShot1500 from '../../../assets/images/web2/home/TMM-Featured-1500.jpg';

import groupShot1500 from '../../../assets/images/web2/home/Twitter-1500.jpg';
import groupShot2250 from '../../../assets/images/web2/home/Twitter-2250.jpg';
import groupShot3000 from '../../../assets/images/web2/home/Twitter-3000.jpg';
import staticData from '@/config/globalConfigStaticData/landing_chappelle';

export default {
  name: 'HomePagePromoBanner',
  data() {
    return {
      imageSrc: groupShot1500,
      imageSrcset: [
        `${groupShot1500} 1024w`,
        `${groupShot2250} 1536w`,
        `${groupShot3000} 2048w`,
      ].join(', '),
      imageSizes: [
        '(max-width: 576px) 100vw',
        '(max-width: 768px) 386px',
        '(max-width: 1024px) 642px',
        '(max-width: 1200px) 838px',
        '955px',
      ].join(', '),
    };
  },
  methods: {
    handleCTAClick(btnId) {
      this.$analytics.track('Home Promo Click', {
        screen_name: this.$route.name,
        path: this.$route.path,
        btnId,
      });
      this.$router.push(staticData.podcastLink);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables.scss";

$mm-light-title-color: #F3F1D5;
$mm-light-text-color: #F7F8DE;
$mm-dark-color: #89B1AA;
$mm-almost-black: #121C30;

.promo {
  font-family: "Inter", sans-serif;
  background-color: $mm-almost-black;
  padding: 0 0 62px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  @media(max-width: $xs) {
    background: linear-gradient(180deg, #1B263C 0%, #010D25 78.12%, #1B263C 89.58%);
    padding: 0 0 68px 0;
  }
  &-container {
    flex: 1 1 auto;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    @media(max-width: $xs) {
      flex-flow: row wrap;
    }
  }
  &-description {
    box-sizing: border-box;
    padding-top: 70px;
    text-align: center;
    @media(max-width: $xs) {
      flex: 1 1 auto;
      order: 2;
    }
  }
  &-header {
    font-family: $serif;
    font-size: 40px;
    line-height: 40px;
    letter-spacing: -0.003em;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 16px;
    @media(max-width: $xs) {
      text-align: center;
      font-size: 34px;
      line-height: 40px;
    }
  }
  &-subtitle {
    font-size: 14px;
    line-height: 21px;
    color: #FFFFFF;
    margin-top: 8px;
    margin-bottom: 18px;
    @media(max-width: $md) {
      margin-bottom: 13px;
    }
    @media(max-width: $sm) {
      font-size: 12px;
      line-height: 19px;
    }
    @media(max-width: $xs) {
      margin: 12px auto 18px;
      max-width: 260px;
      font-size: 18px;
      line-height: 23px;
      text-align: center;
    }
  }
  &-text {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    text-transform: uppercase;
    color: #FFFFFF;
    margin-bottom: 15px;
    @media(max-width: $sm) {
      font-size: 13px;
      line-height: 24px;
      margin-bottom: 13px;
    }
    @media(max-width: $xs) {
      text-align: center;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 36px;
    }
  }
  &-image {
    width: 100%;
    flex: 1 1 auto;
    img {
      width: 100%;
      @media (max-width: $md) {
        height: 266px;
        overflow: hidden;
        width: auto;
      }
      @media (max-width: $xs) {
        height: 209px;
      }
      @media (max-width: $xxs) {
        height: 190px;
        margin-left: 50px;
      }
    }
    @media(max-width: $xs) {
      order: 1;
    }
  }
  &-listen {
    text-align: center;
  }
  &-button {
    z-index: 1000;
    cursor: pointer;
    width: 244px;
    height: 40px;
    outline: none;
    background-color: $mm-light-title-color;
    color: $mm-almost-black;
    font-weight: 700;
    font-size: 17px;
    border: 0;
  }
}
.cta-button {
  min-width: 232px;
  padding: 16px 28px;
  font-size: 16px;
}
</style>
